module.exports = __webpack_public_path__ + "img/Speaker=Justin Zheng.711fafdd.png";